import cart from '../helpers/cart';
import log from '../helpers/log';
import miniBasket from './miniBasket';
import btnCheckout from './btnCheckout';
import { facebookAddToCart } from '../helpers/utilities';

interface IDetail {
  key: string,
  quantity: number,
  variantId: number,
  price: string
}

class Quantity {
  init() {
    const quantities = document.querySelectorAll('[data-quantity]');
    quantities.forEach((quantity:HTMLInputElement) => this.load(quantity));
  }

  load(quantity:HTMLInputElement) {
    quantity.addEventListener('change', this.handleChange.bind(this, quantity));
    const plus = quantity.parentNode.querySelector('[data-quantity-plus]');
    const minus = quantity.parentNode.querySelector('[data-quantity-minus]');
    if (plus) plus.addEventListener('click', this.handleClickPlus.bind(this, quantity));
    if (minus) minus.addEventListener('click', this.handleClickMinus.bind(this, quantity));
    document.addEventListener('quantity:change', this.handleQuantityChange.bind(this, quantity));
  }

  handleClickPlus(quantity:HTMLInputElement) {
    let value = parseInt(quantity.value) + 1;
    this.update(quantity, value);
  }

  handleClickMinus(quantity:HTMLInputElement) {
    let value = parseInt(quantity.value) - 1;
    this.update(quantity, value);
  }

  handleChange(quantity:HTMLInputElement) {
    let value = parseInt(quantity.value);
    this.update(quantity, value);
  }

  handleQuantityChange(quantity:HTMLInputElement) {
    btnCheckout.loaded();
    this.enable(quantity);
  }

  async update(quantity:HTMLInputElement, value: number) {
    this.disable(quantity);
    btnCheckout.loading();
    const variantId = parseInt(quantity.dataset.variantId);
    const max = parseInt(quantity.max);
    const price = quantity.dataset.price;
    if (value > max) value = max, quantity.value = quantity.max;
    this.request({
      key: quantity.dataset.key,
      quantity: value,
      variantId: variantId,
      price: price
    });
  }

  disable(quantity:HTMLInputElement) {
    const plus: HTMLInputElement = quantity.parentNode.querySelector('[data-quantity-plus]');
    const minus: HTMLInputElement = quantity.parentNode.querySelector('[data-quantity-minus]');
    if (plus) plus.classList.add('quantity--disabled');
    if (minus) minus.classList.add('quantity--disabled');
  }

  enable(quantity:HTMLInputElement) {
    const plus: HTMLInputElement = quantity.parentNode.querySelector('[data-quantity-plus]');
    const minus: HTMLInputElement = quantity.parentNode.querySelector('[data-quantity-minus]');
    if (plus) plus.classList.remove('quantity--disabled');
    if (minus) minus.classList.remove('quantity--disabled');
  }

  async request(detail:IDetail) {
    const updates:any = {};
    updates[detail.variantId] = detail.quantity;
    try {
      facebookAddToCart(await cart.update({ updates }));
      miniBasket.update();
      this.dispatchEvent(detail);
    }
    catch(error) {
      log.error(error);
    }
  }

  dispatchEvent(detail:IDetail) {
    document.dispatchEvent(new CustomEvent('quantity:change', { detail }));
  }
}

export default new Quantity();